import React from "react";
import "./SpecialBody.css";

const Special_Body = () => {
  return (
    <div class="standing">
      <div class="container">
        <div class="col-md-12">
          <div class="standing-list-cover">
            <div class="standing-team-list">
              <h4 class="result-title ">specials</h4>
              <table class="table table-dark table-hover table-striped">
                <thead>
                  <tr>
                    <th scope="col">Bet Description</th>
                    <th scope="col">Odds</th>
                    <th scope="col">Start Time</th>
                    <th scope="col">Bet</th>
                    <th scope="col">Result</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>lorem</td>
                    <td>lorem</td>
                    <td>lorem</td>
                    <td>lorem</td>
                    <td>lorem</td>
                  </tr>
                  <tr>
                    <td>lorem</td>
                    <td>lorem</td>
                    <td>lorem</td>
                    <td>lorem</td>
                    <td>lorem</td>
                  </tr>
                  <tr>
                    <td>lorem</td>
                    <td>lorem</td>
                    <td>lorem</td>
                    <td>lorem</td>
                    <td>lorem</td>
                  </tr>
                  <tr>
                    <td>lorem</td>
                    <td>lorem</td>
                    <td>lorem</td>
                    <td>lorem</td>
                    <td>lorem</td>
                  </tr>
                  <tr>
                    <td>lorem</td>
                    <td>lorem</td>
                    <td>lorem</td>
                    <td>lorem</td>
                    <td>lorem</td>
                  </tr>
                  <tr>
                    <td>lorem</td>
                    <td>lorem</td>
                    <td>lorem</td>
                    <td>lorem</td>
                    <td>lorem</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Special_Body;
